import classNames from 'clsx';
import React from 'react';

import type { GlobalFieldReference, ProspectHomepageSlide } from '@swf/cms';
import type { IconsGridBlock } from '@swf/generated/cms/types/ProspectHomepageSlide';

import CardContentItem from '../CardContentItem/CardContentItem';

import styles from './ColumnLayout.scss';

interface Props {
  contentRowsCount: number;
  contents: ProspectHomepageSlide['content'][];
}

type ContentItem = GlobalFieldReference | IconsGridBlock;

const Contents: React.FC<Props> = ({ contentRowsCount, contents }) => {
  const contentRows: ContentItem[][] = [];

  for (let i = 0; i < contentRowsCount; i++) {
    contentRows.push([]);
    for (const content of contents) {
      contentRows[i].push(content[i]);
    }
  }

  return (
    <>
      {contentRows.map((cr: ContentItem[], rowIndex: number) => (
        <div key={rowIndex} className={styles.row}>
          {cr.map((item: ContentItem, itemIndex: number) => {
            const itemClasses = classNames(styles.contentItem, {
              [styles.lastRow]: rowIndex === contentRows.length - 1
            });
            return item ? (
              <CardContentItem key={itemIndex} className={itemClasses} item={item} />
            ) : (
              <div key={itemIndex} className={itemClasses} />
            );
          })}
        </div>
      ))}
    </>
  );
};

export default Contents;
